import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Layout from '../components/layout';
import PageComponent from '../pagesComponents/pageWithCards';

const IndexPage = ({ data, location }) => (
  <Layout location={location}>
    <PageComponent data={data} />
  </Layout>
);

IndexPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.object.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default IndexPage;

export const query = graphql`
query esMainCardQuery 
{
  allMarkdownRemark(
    filter: { frontmatter: { language: { eq: "es"} } }
    sort: { order: DESC, fields: [frontmatter___date] }
    limit: 1000
  ) {
    edges {
      node {
        frontmatter {
          date,
          title,
          image,
          language,
          previewText,
          category
        }
      }
    }
  }
}
`;
